import React, {PureComponent} from 'react';
import {CardBody, CardText, CardTitle} from 'reactstrap';

import BackCard from '../BackCard.jsx';
import Date from '../../../../shared/components/Moment/Date.jsx';

export default class OfferBackCard extends PureComponent {
  renderSummary = (summary, charMax) => {
    if (!summary) {
      return null;
    }

    return (summary.length > charMax ? `${summary.substring(0, charMax)}...` : summary)
      .replace(/(<([^>]+)>)/ig, "");
  };

  render() {
    const {offer} = this.props;

    return (
      <BackCard className="h-100 text-center">
        <CardBody className="bg-secondary">
          <div className="text-right">
            <Date date={offer.start_date}/>
          </div>
          <div className="my-2">
            <CardTitle>{offer?.title ?? ''}</CardTitle>
            <p className="m-0">{offer?.duration ?? ''}</p>
            <p className="m-0">{offer?.city.label ?? ''}</p>
          </div>
          <div className="separator-x bg-gray-50"/>
          <CardText>{this.renderSummary(offer.description, 300)}</CardText>
        </CardBody>
      </BackCard>
    );
  }
}
